
export const getHouseholdInitials = (householdName: string): string => {
  try {
    const splitName = householdName.toUpperCase().split(" ");
    return splitName[0][0] + splitName[1][0];
  } catch (error) {
    return "IC";
  }
};